import httpService from "./httpService";

export default {
  findAllByHcCaseCalendarId(hcCaseCalendarId) {
    return httpService.get("hcCaseCalendarBanLanhDao/findAllByHcCaseCalendarId", {
      params: {hcCaseCalendarId}
    });
  }
};




// WEBPACK FOOTER //
// ./src/services/hcCaseCalendarBanLanhDaoService.js